if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        (async() => {
          const cart = await fetch(`${routes.cart_url}.json`).then((d) => d.json()).catch((r) => r);
          window.cartAttributes = Object.entries(cart.attributes);
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
  
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        })();
      }

      getNewAttribute(name, value, formData) {
        const attribute = cartAttributes.find(([attributeName, _]) => 
          `attributes[${attributeName}]` === name
          || `attributes.list[${attributeName}]` === name
        );
        const isList = name.indexOf('.list') !== -1;
        formData.delete(name);
        const newName = name.replace('.list', '');
        if (!attribute) return [newName, value];

        let newValue = value;
        if (isList) {
          newValue = `${attribute.at(1)},${value}`;
          newValue = [...new Set(newValue.split(','))].join(',')
        }
        return [newName, newValue];
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        [...formData.entries()].forEach(([name, value]) => {
          if (name.indexOf('attributes') === -1) return;
          formData.append(...this.getNewAttribute(name, value, formData))
        });
        const nextAttributes = cartAttributes.filter(([name]) => [...formData.keys()].filter((i)=>i.indexOf('attributes')!==-1).indexOf(`attributes[${name}]`)===-1);
        nextAttributes.forEach(([name, value]) => formData.append(`attributes[${name}]`, value));
        cartAttributes = [...formData.entries()].reduce((p, [name, value]) => {
          if (name.indexOf('attributes') === -1) return p;
          return [...p, [
            name.replace('attributes[', '').replace(']', ''),
            value
          ]];
        }, []);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = document.querySelector('[id^="QuickAdd-"][open]');
            if (quickAddModal) {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
              quickAddModal.close(quickAddModal);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
